import { useState } from 'react';
import { X } from 'lucide-react';
import { gallery } from '../../mock';

const captions = [
  'Freshly mown lawn with crisp mowing stripes in a Ballarat backyard',
  'Neatly striped green lawn after a professional mow in Ballarat',
  'Tidy striped lawn edged along a backyard fence in Ballarat',
  'Healthy lawn with sharp edges beside a paved path in Ballarat',
  'Manicured lawn and garden bed with clean paver edging in Ballarat',
  'Lawn mowing in progress with a tidy, even finish in Ballarat',
  'Open lawn and young trees maintained along a landscaped path',
  'Premium lawn, garden bed and streetscape finish in Ballarat',
];

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" className="py-24 cream-alt-bg">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-10 reveal">
          <div className="lg:col-span-7">
            <p className="section-label mb-4">Projects</p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05]">
              Real Ballarat properties, real finishes.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#212B20] text-lg leading-relaxed">
              A selection of recent lawn mowing, gardening, weed control, and acreage mowing
              jobs across Ballarat and nearby suburbs.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {gallery.slice(0, 8).map((src, i) => {
            const caption = captions[i] || 'Lawn and garden maintenance project in Ballarat by VGLM';
            return (
              <button
                key={`gallery-${i}-${src.slice(-24)}`}
                onClick={() => setActive({ src, caption })}
                aria-label={`View larger: ${caption}`}
                className="reveal relative overflow-hidden rounded-lg aspect-[4/5] group focus:outline-none border border-[#E2DAC5]"
                style={{ transitionDelay: `${(i % 4) * 90}ms` }}
              >
                <img src={src} alt={caption} width="400" height="500" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A2E18]/85 via-[#0A2E18]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <span className="absolute bottom-0 left-0 right-0 p-3 text-left text-white text-xs font-semibold leading-snug translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                  {caption}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {active && (
        <div className="fixed inset-0 z-[100] bg-black/85 flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <button onClick={() => setActive(null)} className="absolute top-4 right-4 text-white p-2 rounded-full bg-white/10 hover:bg-white/20" aria-label="Close">
            <X className="w-6 h-6" />
          </button>
          <img src={active.src} alt={active.caption} className="max-h-[90vh] max-w-[95vw] rounded-lg shadow-2xl" />
        </div>
      )}
    </section>
  );
}
